import {RxStomp, RxStompConfig} from '@stomp/rx-stomp';
import {IMessage} from '@stomp/stompjs';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export abstract class StompService {
  private rxStomp = new RxStomp();
  protected abstract getStompConfig(): RxStompConfig;

  public connect() {
    const stompConfig = this.getStompConfig();
    this.rxStomp.configure(stompConfig);
    this.rxStomp.activate();
    return this.rxStomp.connected$;
  }

  public disconnect() {
    return this.rxStomp.deactivate();
  }

  public watch<T>(topic: string): Observable<T> {
    return this.rxStomp.watch(topic)
      .pipe(map<IMessage, T>(function (message) {
        return JSON.parse(message.body);
      }));
  }

  public publish<T = undefined>(destination: string, message: T = undefined, retries: number = 3) {
    if (retries === 0) {
      throw new Error('Broker disconnected, can\'t send message.');
    }
    if (!this.rxStomp.connected()) {
      setTimeout(() => this.publish(destination, message, retries - 1), 700);
      return false;
    }
    let body;
    if (message !== undefined) {
      body = JSON.stringify({ message });
    }
    this.rxStomp.publish({ destination: `/app/ws${destination}`, body });
    return true;
  }
}
